/* ELM 2026-10-22: Wokiee starts the phone product-photo slider (theme.js, initttMobileProductSlider) and slick throws
   "Cannot read properties of null (reading 'add')" in its accessibility step. On phones that error stopped the rest of the
   page start-up, so "You may also like" (related products) never loaded on any product page. Slick calls are now guarded:
   a slider error is logged as a warning and the page carries on. Loaded after vendor.min.js and before theme.js. */
(function ($) {
  if (!$ || !$.fn || !$.fn.slick || $.fn.slick.elmGuarded) return;
  var original = $.fn.slick;
  var guarded = function () {
    try { return original.apply(this, arguments); }
    catch (err) { if (window.console && console.warn) console.warn('ELM slider guard:', err && err.message); return this; }
  };
  for (var k in original) { if (Object.prototype.hasOwnProperty.call(original, k)) guarded[k] = original[k]; }
  guarded.elmGuarded = true;
  $.fn.slick = guarded;
})(window.jQuery);
